module.exports = __webpack_public_path__ + "media/img/home/clients-map/map1-67015babca701c0d93830dfb8e4dcc98.png";